"use client";

import React from "react";
import { useHeader } from "@/components/project/Header";
import Button from "@/components/ui/Button";
import Drawer from "@/components/ui/Drawer";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { MobileNavProps } from "../types";

function MobileNav({ className, ...props }: MobileNavProps) {
  const { toggleIsVisible } = useHeader();
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const handleOnClick = React.useCallback(() => {
    toggleIsVisible();
  }, [toggleIsVisible]);

  return (
    <Drawer.Trigger className={cn(className, classes)} {...native} asChild>
      {/* `flex md:hidden` belongs on Button.Icon, NOT on the asChild
          Drawer.Trigger: Radix Slot concatenates className with no
          tailwind-merge, so a display utility there would not dedupe against
          buttonVariants' `inline-flex` base. */}
      <Button.Icon
        icon="menu"
        variant="outline"
        aria-label="Open Navigation Menu"
        onClick={handleOnClick}
        className="flex md:hidden"
      />
    </Drawer.Trigger>
  );
}

MobileNav.displayName = "MobileNav";

export default MobileNav;
